import { ErrorImage } from '../../../ErrorImage'

export function Error500Image() {
  return <ErrorImage src="/images/500.png" alt="Error-500" />
}
